export const ROLES_SUPPLIER = 'ROLES_SUPPLIER';
export const ROLES_RETAILER = 'ROLES_RETAILER';
export const ROLES_USER = 'ROLES_USER';
export const ROLES = 'ROLES';
export const ROLES_CURRENT_ROLE = 'ROLES_CURRENT_ROLE';
export const ROLES_SUPPLIER_ID = 'ROLES_SUPPLIER_ID';
export const ROLES_RETAILER_ID = 'ROLES_RETAILER_ID';
export const ROLES_CLEAR_PERMISSIONS = 'ROLES_CLEAR_PERMISSIONS';
export const ROLES_RETAILER_SUPPLIERS = 'ROLES_RETAILER_SUPPLIERS';
export const LOAD_USER_NOTIFICATIONS = 'LOAD_USER_NOTIFICATIONS';
